import { AuthCredentials, LoginFormEntity } from './auth.models';
import { UserRequestDTO, UserRoles } from './user.model';

export interface RegistrationFormEntity {
  first_name: string;
  last_name: string;
  username: string;
  password: string;
  confirm_password: string;
  role: UserRoles;
}

export const isEmail = (textInput: string) => {
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(textInput);
};

export class UserDTO implements UserRequestDTO {
  username: string;
  role?: UserRoles | undefined;
  name: { firstName: string; lastName: string };
  email?: string | undefined;
  mobile?: string | undefined;
  password: string;

  constructor(registrationForm: RegistrationFormEntity) {
    this.name = {
      firstName: registrationForm.first_name,
      lastName: registrationForm.last_name,
    };
    this.password = registrationForm.password;
    this.role = registrationForm.role;

    if (isEmail(registrationForm.username)) {
      this.email = registrationForm.username;
      this.username = this.email;
    } else {
      const formattednumber = registrationForm.username.replace(
        /^(0094|0|94|\+94)/,
        '+94'
      );
      this.username = this.mobile = formattednumber;
    }
  }
}

export class AuthCredentialsDTO implements AuthCredentials {
  username: string;
  password: string;

  constructor(loginForm: LoginFormEntity) {
    this.password = loginForm.password;

    if (isEmail(loginForm.username)) {
      this.username = loginForm.username;
    } else {
      const formattednumber = loginForm.username.replace(
        /^(0094|0|94|\+94)/,
        '+94'
      );
      this.username = formattednumber;
    }
  }
}
